import _ from 'lodash'
import moment from 'moment-timezone'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Container, Image, Menu, Segment, Tab } from 'semantic-ui-react'

import nav from '../../../assets/images/angle-gray.png'
import { send } from '../../../helpers/requests'
import { format } from '../../../helpers/timezones'
import { tr } from '../../../helpers/languages'

class Modules extends Component {
    constructor (props) {
        super(props)
        this.MAX = 5
        this.STEP = 4
        this.state = {
            modules: [],
            count: 0,
            start: -1,
            end: -1,
            index: -1,
            patientid: -1
        }
        autoBind(this)
    }

    componentDidMount () {
        if (this.props.userTokens.accessToken.token) {
            // Fetch the modules.
            // this.fetchModules()
            this.setModules()
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            // Fetch the modules.
            // this.fetchModules()
            this.setModules()
        }
        let index = _.findIndex(this.state.modules, (m) => { return m.id === nextProps.module })
        if (index === this.state.index) {
            return
        }
        if (index >= 0) {
            let start
            let end
            if (this.state.count <= this.MAX) {
                end = this.state.count - 1
                start = 0
            } else {
                const left = index
                const right = this.state.count - index - 1
                if (left < this.MAX) {
                    start = 0
                    end = index + this.MAX - left - 1
                } else if (right < this.MAX) {
                    end = this.state.count - 1
                    start = index - (this.MAX - right - 1)
                } else {
                    end = index + 2
                    start = index - 2
                }
            }
            this.setState({ start, end, index })
        }
    }

    setModules() {
        this.setState({
            patientid: this.props.match.params.id
        })
        const data = this.props.participant_details[this.props.match.params.id]
        const now = moment()
            .tz(this.props.timezone)
            .valueOf()
        // Keep only the past modules and the current one (if any).
        let modules = data.modules.filter((m) => {
            return parseInt(m.start, 10) <= now
        })
        if (this.props.with0) {
            modules = [{ id: '0', title: tr('WEEK') + ' 1' }].concat(modules)
        }
        const count = modules.length
        let index = _.findIndex(modules, (m) => { return m.id === this.props.module })
        let module
        if (index >= 0) {
            module = modules[index]
            let start
            let end
            if (count <= this.MAX) {
                end = count - 1
                start = 0
            } else {
                const left = index
                const right = count - index - 1
                if (left < this.MAX) {
                    start = 0
                    end = index + this.MAX - left - 1
                } else if (right < this.MAX) {
                    end = count - 1
                    start = index - (this.MAX - right - 1)
                } else {
                    end = index + 2
                    start = index - 2
                }
            }
            this.setState({ start, end, modules, index, count })
        } else {
            module = _.last(modules)
            index = count - 1
            const end = count - 1
            const start = Math.max(0, end - this.MAX + 1)
            this.setState({ start, end, modules, index, count })
        }
        this.props.onChangeModule(module ? module.id : undefined)
    }

    // Fetches the participant's modules.
    fetchModules () {
        // eslint-disable-next-line no-console
        if (this.state.patientid !== this.props.match.params.id) {
            this.setState({
                patientid: this.props.match.params.id
            })
            console.log('Fetch modules.')
            return send({
                method: 'GET',
                tokens: this.props.userTokens,
                url: `/patients/${this.props.match.params.id}`
            })
                .then((response) => {
                    // eslint-disable-next-line no-console
                    console.log('Fetched modules.')
                    const data = response.data
                    const now = moment()
                        .tz(this.props.timezone)
                        .valueOf()
                    // Keep only the past modules and the current one (if any).
                    let modules = data.modules.filter((m) => {
                        return parseInt(m.start, 10) <= now
                    })
                    if (this.props.with0) {
                        modules = [{ id: '0', title: tr('WEEK') + ' 1' }].concat(modules)
                    }
                    const count = modules.length
                    let index = _.findIndex(modules, (m) => { return m.id === this.props.module })
                    let module
                    if (index >= 0) {
                        module = modules[index]
                        let start
                        let end
                        if (count <= this.MAX) {
                            end = count - 1
                            start = 0
                        } else {
                            const left = index
                            const right = count - index - 1
                            if (left < this.MAX) {
                                start = 0
                                end = index + this.MAX - left - 1
                            } else if (right < this.MAX) {
                                end = count - 1
                                start = index - (this.MAX - right - 1)
                            } else {
                                end = index + 2
                                start = index - 2
                            }
                        }
                        this.setState({ start, end, modules, index, count })
                    } else {
                        module = _.last(modules)
                        index = count - 1
                        const end = count - 1
                        const start = Math.max(0, end - this.MAX + 1)
                        this.setState({ start, end, modules, index, count })
                    }
                    this.props.onChangeModule(module ? module.id : undefined)
                })
                .catch((error) => {
                    // Failed to fetch modules.
                    // eslint-disable-next-line no-console
                    console.error('Failed to fetch modules.', error)
                    // Hide the error.
                })
        }
    }

    // Changes to the module at the given index.
    changeModule (index) {
        let start = this.state.start
        let end = this.state.end
        if (index < this.state.start || index > this.state.end) {
            // There must be at least MAX modules. Otherwise, index could never fall outside [start,end];
            const left = index
            const right = this.state.count - index - 1
            if (left < this.MAX / 2) {
                start = 0
                end = index + (this.MAX - left)
            } else if (right < this.MAX / 2) {
                start = index - (this.MAX - right)
                end = this.state.count - 1
            } else {
                start = index - 2
                end = index + 2
            }
        }
        this.setState({ start, end, index }, () => {
            this.props.onChangeModule(this.state.modules[index].id)
        })
    }

    peekBack () {
        const n = Math.min(this.state.start, this.STEP)
        this.setState({ start: this.state.start - n, end: this.state.end - n })
    }

    peekFront () {
        const n = Math.min(this.state.count - this.state.end - 1, this.STEP)
        this.setState({ start: this.state.start + n, end: this.state.end + n })
    }

    render () {
        if (_.isEmpty(this.state.modules)) {
            return null
        }
        const modules = this.state.modules.slice(this.state.start, this.state.end + 1)
        let panes = []
        const previous = {
            menuItem: (
                <Menu.Item className='module-nav previous' index={0} disabled key='module-nav-prev'>
                    {
                        this.state.start > 0 && (
                            <Image className='previous' src={nav} onClick={(_e) => { this.peekBack() }}/>
                        )
                    }
                </Menu.Item>
            ),
            render: () => {
                return null
            }
        }
        const next = {
            className: 'module-nav',
            menuItem: (
                <Menu.Item className='module-nav next' index={this.MAX + 1} disabled key='module-nav-next'>
                    {
                        this.state.end < this.state.count - 1 && (
                            <Image className='next' src={nav} onClick={(_e) => { this.peekFront() }}/>
                        )
                    }
                </Menu.Item>
            ),
            render: () => {
                return null
            }
        }
        panes = panes.concat([previous])
        panes = panes.concat(modules.map((module, index) => {
            return {
                menuItem: (
                    <Menu.Item className='module-name' index={index + 1} key={`module${module.id}`}>
                        <span>{module.title}</span>
                    </Menu.Item>
                ),
                render: () => {
                    return null
                }
            }
        }))
        panes = panes.concat([next])
        return (
            <Container className='modules'>
                <Tab
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                    activeIndex={this.state.index - this.state.start + 1}
                    onTabChange={
                        (_e, { activeIndex }) => {
                            if (activeIndex === 0) {
                                return
                            }
                            if (activeIndex === this.MAX + 1) {
                                return
                            }
                            this.changeModule(this.state.start + activeIndex - 1)
                        }
                    }
                />
                <Segment className='module-date'>
                    {
                        this.state.modules[this.state.index].start && this.state.modules[this.state.index].end ? `${format(this.state.modules[this.state.index].start, 'DD/MM/YYYY', this.props.timezone, this.props.language)}  - ${format(this.state.modules[this.state.index].end, 'DD/MM/YYYY', this.props.timezone, this.props.language)}` : ''
                    }
                </Segment>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        module: state.participants.location.module,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens,
        participant_details: state.participants.participant_details
    }
}

const mapDispatchToProps = (_dispatch) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modules))



// WEBPACK FOOTER //
// ./src/components/common/modules/index.js